import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowHeadToRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	className: "arrow-head",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 54.3 138.6",
	style: { enableBackground: "new 0 0 54.3 138.6" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
			className: "arrow-head__backdrop",
			x: 1.6,
			width: 50.6,
			height: 138.6
		}) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__space-between",
				d: "M16.4,2.5L16.4,2.5L16.4,2.5c-0.5-0.9-1.1-1.8-1.8-2.5h-13c4,0,7.6,2.1,9.6,5.5l33.5,58.3c2,3.4,2,7.6,0,11 l-33.6,58.3c-1.9,3.4-5.6,5.5-9.5,5.5h13c0.7-0.8,1.3-1.6,1.8-2.5L50,77.9c1.5-2.6,2.3-5.6,2.3-8.5s-0.8-5.9-2.3-8.5L16.4,2.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__tip",
				d: "M11.1,133.1l33.6-58.3c2-3.4,2-7.6,0-11L11.2,5.5C9.2,2.1,5.6,0,1.6,0H0v138.6h1.6 C5.5,138.6,9.2,136.5,11.1,133.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "arrow-head__bg",
				d: "M52.2,0H14.7c0.6,0.8,1.2,1.6,1.8,2.5l0,0l0,0L50,60.8c1.5,2.6,2.3,5.6,2.3,8.5s-0.8,5.9-2.3,8.5L16.4,136 c-0.5,0.9-1.1,1.8-1.8,2.5h37.6h2.1V0H52.2z"
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgArrowHeadToRight);
export default ForwardRef;
